import * as React from 'react';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import Barcode from 'react-barcode';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../context/DataContext';

const getBarcode3 = ({ date, insurancePrice, barcode1, barcode2 }) => {
  let str = date.slice(2) + '00' + insurancePrice.padStart(9, '0');

  let oddSum = 0;
  let evenSum = 0;

  const mapping = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
    F: 6,
    G: 7,
    H: 8,
    I: 9,
    J: 1,
    K: 2,
    L: 3,
    M: 4,
    N: 5,
    O: 6,
    P: 7,
    Q: 8,
    R: 9,
    S: 2,
    T: 3,
    U: 4,
    V: 5,
    W: 6,
    X: 7,
    Y: 8,
    Z: 9,
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
  };

  barcode1.split('').forEach((char, index) => {
    if (index % 2) evenSum += mapping[char];
    else oddSum += mapping[char];
  });

  barcode2.split('').forEach((char, index) => {
    if (index % 2) evenSum += mapping[char];
    else oddSum += mapping[char];
  });

  str.split('').forEach((char, index) => {
    if (index % 2) evenSum += mapping[char];
    else oddSum += mapping[char];
  });

  const checksum1 =
    oddSum % 11 === 0 ? 'A' : oddSum % 11 === 10 ? 'B' : oddSum % 11;
  const checksum2 =
    evenSum % 11 === 0 ? 'X' : evenSum % 11 === 10 ? 'Y' : evenSum % 11;

  return str.substring(0, 4) + checksum1 + checksum2 + str.substring(6);
};

const BarcodePage = () => {
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const {
    state: {
      customerInfo: { imei, insurancePrice, orderId },
    },
    checkBarcodePaid,
  } = React.useContext(Context);
  const date = DateTime.now().minus({ year: 1911 }).toFormat('yyMMdd');
  const barcode1 = `${date}GTT`;
  const barcode2 = imei.padEnd(16, '0');
  const barcode3 = getBarcode3({ date, insurancePrice, barcode1, barcode2 });

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        現金繳費
      </Typography>
      <Box>
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Barcode value={barcode1} format="CODE39" width={1.1} height={50} />
          <Barcode value={barcode2} format="CODE39" width={1.1} height={50} />
          <Barcode value={barcode3} format="CODE39" width={1.1} height={50} />
        </Box>
        {errorMsg ? (
          <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          {process.env.REACT_APP_ENV === 'production' ||
          process.env.REACT_APP_ENV === 'leaguetech-production' ? null : (
            <Button
              color="info"
              variant="contained"
              sx={{ width: 168 }}
              onClick={() => {
                navigate('/upload-photos');
              }}
            >
              測試用下一步
            </Button>
          )}
          <LoadingButton
            variant="contained"
            sx={{ width: 168 }}
            loading={loading}
            onClick={() => {
              setLoading(true);
              checkBarcodePaid(
                {
                  orderId,
                  barcode1,
                  barcode2,
                  barcode3,
                },
                ({ responseCode, responseMsg }) => {
                  setLoading(false);
                  if (responseCode === '000') {
                    navigate('/upload-photos');
                  } else {
                    setErrorMsg(responseMsg);
                  }
                }
              );
            }}
          >
            確認繳費結果
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default BarcodePage;
